import { Grid } from '@simplywallst/ui-core';
import KeyMetric from '../KeyMetric';
import { MetricWrapper } from './styled';

interface KeyMetrics {
  title: string;
  value: string;
  tooltip?: string | null;
}

interface Props {
  keyMetrics?: [KeyMetrics] | [KeyMetrics, KeyMetrics];
}

export const RowKeyMetrics = ({ keyMetrics }: Props) => {
  if (typeof keyMetrics === 'undefined') return null;
  return (
    <Grid template={`none / repeat(${keyMetrics?.length}, 1fr)`}>
      {keyMetrics.map((metric, i) => (
        <MetricWrapper key={i}>
          <KeyMetric
            title={metric.title}
            tooltip={metric.tooltip}
            value={metric.value}
          />
        </MetricWrapper>
      ))}
    </Grid>
  );
};
